import {Fragment, useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {FormulaTypeService} from '../FormulaTypeService';

import {useDataTableBasic} from '../../../../shared/hooks/DataTableBasic';

import DialogSetFormula from './DialogSetFormula';

export default function DialogFormulas(props) {

  const {setting, formulaField, formulasField, invoiceGroups, allSettings} = props;

  const [display, setDisplay] = useState(false);

  const [formulaTypes, setFormulaTypes] = useState([]);
  const [formulaTypeMap, setFormulaTypeMap] = useState({});

  const [formulas, setFormulas] = useState([]);
  const [displaySetFormula, setDisplaySetFormula] = useState(0);
  const [editingFormula, setEditingFormula] = useState(null);

  useEffect(() => {
    FormulaTypeService.getList({}).then(({items}) => {
      const _formulaTypes = [], _formulaTypeMap = {};
      items.forEach(item => {
        _formulaTypes.push({value: item.code, label: item.name});
        _formulaTypeMap[item.code] = item.name;
      });
      setFormulaTypes(_formulaTypes);
      setFormulaTypeMap(_formulaTypeMap);
    });
  }, []);

  useEffect(() => {
    setDisplay(!!props.display);
  }, [props.display]);

  useEffect(() => {
    if (setting && formulasField) {
      if (setting[formulasField] && setting[formulasField].length) {
        const _formulas = [];
        setting[formulasField].forEach(f => {
          f._id = f.id;
          _formulas.push(f);
        });
        setFormulas(_formulas);
      } else {
        setFormulas([]);
      }
    }
  }, [setting, formulasField]);

  const deleteFormula = (formula) => {
    const _formulas = formulas.filter((f) => f._id !== formula._id);
    setFormulas(_formulas);
  }

  const editFormula = (formula) => {
    setEditingFormula(formula);
    setDisplaySetFormula(Date.now);
  }

  let columns;
  if (setting.multipleFormula) {
    columns = [
      {
        field: 'formulaType', header: 'Cách tính', sortable: false, dataType: 'custom', customCell(rowData: any): string {
          return formulaTypeMap[rowData.formulaType]
        }, style: {minWidth: '150px', maxWidth: '150px'}
      },
      {field: 'formulaLable', header: 'Công thức', sortable: false, style: {minWidth: '250px'}},
      {
        field: '', header: '', sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <Fragment>
              <Button icon="pi pi-pencil" onClick={() => editFormula(rowData)}
                      title="Xoá" className="p-button-rounded p-button-outlined p-button-warning p-button-sm mr-1"/>
              <Button icon="pi pi-trash" onClick={() => deleteFormula(rowData)}
                      title="Xoá" className="p-button-rounded p-button-outlined p-button-danger p-button-sm"/>
            </Fragment>
          )
        }, style: {minWidth: '90px', maxWidth: '90px'}
      }
    ];
  } else {
    columns = [
      {field: 'formulaLable', header: 'Công thức', sortable: false, style: {minWidth: '250px'}},
      {
        field: '', header: '', sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <Fragment>
              <Button icon="pi pi-pencil" onClick={() => editFormula(rowData)}
                      title="Xoá" className="p-button-rounded p-button-outlined p-button-warning p-button-sm mr-1"/>
              <Button icon="pi pi-trash" onClick={() => deleteFormula(rowData)}
                      title="Xoá" className="p-button-rounded p-button-outlined p-button-danger p-button-sm"/>
            </Fragment>
          )
        }, style: {minWidth: '90px', maxWidth: '90px'}
      }
    ];
  }

  const {render: renderDataTable} = useDataTableBasic({
    dataKey: 'id',
    columns,
    items: formulas
  });

  const addFormula = () => {
    setDisplaySetFormula(Date.now);
  }

  const onFormulaSubmit = ({formulaType, formula}) => {
    if (formula) {
      const formulaLabel = [], formulaBe = [];
      formula.forEach((item: any) => {
        formulaLabel.push(item.label);
        if (item.type === 'parameter') {
          formulaBe.push(`${item.groupTypeCode}.${item.fieldName}`);
        } else {
          formulaBe.push(item.value);
        }
      });

      const modifiedFormula: any = {
        formulaType,
        formulaLable: formulaLabel.join(' '),
        formulaFe: JSON.stringify(formula),
        formulaBe: formulaBe.join(' ')
      };

      const _formulas = [...formulas];
      if (editingFormula) {
        for (let f of _formulas) {
          if (f._id === editingFormula._id) {
            f = Object.assign(f, modifiedFormula);
          }
        }
      } else {
        modifiedFormula._id = `added-field-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}`;
        _formulas.push(modifiedFormula);
      }
      setFormulas(_formulas);
    }
  }

  const handleSubmit = () => {
    let formula = [];
    if (formulas && formulas.length) {
      formulas.forEach(f => {
        formula.push(f.formulaLable);
      });
    }
    setting[formulaField] = formula.join(', ');
    setting[formulasField] = formulas;
    props.onSubmit();
  }

  return (
    <Fragment>
      <Dialog header={`Công thức tính - ${setting ? setting.lable : ''}`} visible={display} style={{width: '50rem'}} onHide={() => setDisplay(false)}>
        <div className="grid mt-1">
          {(setting.multipleFormula || formulas.length === 0) &&
              <div className="col-12 text-right">
                  <Button icon="pi pi-plus" label="Thêm công thức" className="p-button-outlined p-button-sm" onClick={addFormula}/>
              </div>
          }
        </div>
        {renderDataTable()}
        <div className="flex justify-content-end mt-2">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm mr-2"/>
          <Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} className="p-button-sm"/>
        </div>
      </Dialog>
      <DialogSetFormula display={displaySetFormula} setting={setting} invoiceGroups={invoiceGroups} allSettings={allSettings} formulaTypes={formulaTypes}
                        editingFormula={editingFormula} onSubmit={onFormulaSubmit}/>
    </Fragment>
  );
}
